import {forwardRef, ReactNode, Ref} from 'react'
import {UnnormalizedProps as UnnormalizedStyleProps} from '@yosmanyga/core-style'
import {WithTheme} from '@yosmanyga/theme'
import {NonExistentPrimitiveError, usePrimitives} from '@yosmanyga/primitive-ui-spec'
import {truncate} from "lodash";

type TextProps = {
    intent?: string,

    truncate?: boolean,

    ref?: Ref<unknown>,
    children?: ReactNode
}

const Text = forwardRef<unknown, TextProps>(({
    children,
    ...props
}, ref) => {
    const {Text: BaseText} = usePrimitives()

    if (!BaseText) {
        throw new NonExistentPrimitiveError('Text')
    }

    return <BaseText
        ref={ref}
        {...props}
    >
        {children}
    </BaseText>
})

const TextWithTheme = (props: TextProps & UnnormalizedStyleProps) => {
    return <WithTheme
        {...props}
        identifier='text'
        Component={Text}
    />
}

export default TextWithTheme
